/** Link oficial para deixar uma avaliação no Google Business (Plumaa). */
export const GOOGLE_LEAVE_REVIEW_URL =
	'https://g.page/r/CUWO13MvPmQXEBM/review';

/** Perfil da empresa no Google. */
export const GOOGLE_BUSINESS_PROFILE_URL = 'https://g.page/r/CUWO13MvPmQXEBM';

export const GOOGLE_MAPS_SEARCH_URL =
	'https://www.google.com/maps/search/?api=1&query=Plumaa';

export const GOOGLE_MAPS_EMBED_URL =
	'https://maps.google.com/maps?q=Plumaa&hl=pt&z=14&output=embed';
